import type { ReactNode } from 'react';
import { cx } from '../lib/cx';
import { Button } from './Button';

export interface EmptyStateProps {
  /** Poruka uvijek dolazi iz `@st/i18n` — ARHITEKTURA.md sekcija 10. */
  message: string;
  title?: string;
  actionLabel?: string;
  onAction?: () => void;
  icon?: ReactNode;
  className?: string;
}

export function EmptyState({
  message,
  title,
  actionLabel,
  onAction,
  icon,
  className,
}: EmptyStateProps) {
  return (
    <div
      data-testid="empty-state"
      className={cx(
        'flex flex-col items-center gap-3 rounded-xl border border-dashed border-line',
        'bg-surface px-6 py-12 text-center shadow-card',
        className,
      )}
    >
      <span aria-hidden="true" className="text-accent">
        {icon ?? <Leaf />}
      </span>
      {title && <h3 className="font-display text-[21px] font-semibold text-ink">{title}</h3>}
      <p className="max-w-prose text-[14.5px] leading-relaxed text-ink-muted">{message}</p>
      {actionLabel && onAction && (
        <Button variant="secondary" size="sm" onClick={onAction} className="mt-2">
          {actionLabel}
        </Button>
      )}
    </div>
  );
}

function Leaf() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <path
        d="M20 34V16m0 18c-6 0-11-4-11-10 0-6 5-10 11-10s11 4 11 10c0 6-5 10-11 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
